import { createPinia } from 'pinia'
import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
import { createRouter, createWebHistory } from 'vue-router'
import App from './App.vue'
import AboutPage from './pages/AboutPage.vue'
import LandingPage from './pages/LandingPage.vue'
import PhilosophyPage from './pages/PhilosophyPage.vue'
// import StrategiesPage from './pages/StrategiesPage.vue'
import './styles/main.css'

import ar from './locales/ar.json'
import en from './locales/en.json'
import id from './locales/id.json'

const router = createRouter({
    history: createWebHistory(),
    scrollBehavior() {
        return { top: 0 }
    },
    routes: [
        {
            path: '/',
            name: 'landing',
            component: LandingPage
        },
        // {
        //     path: '/strategies',
        //     name: 'strategies',
        //     component: StrategiesPage
        // },
        {
            path: '/philosophy',
            name: 'philosophy',
            component: PhilosophyPage
        },
        {
            path: '/about',
            name: 'about',
            component: AboutPage
        }
    ]
})

const i18n = createI18n({
    legacy: false,
    locale: localStorage.getItem('locale') || 'en',
    fallbackLocale: 'en',
    messages: {
        en,
        id,
        ar
    }
})

const app = createApp(App)
app.use(createPinia())
app.use(router)
app.use(i18n)
app.mount('#app')
